import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { requestApi } from 'api/Api';

import useModal from 'lib/hooks/useModal';

import { showAlert } from 'components/shared/Alert/Alert';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

import SpecialtyModal from './SpecialtyModal';

export const Actions = ({ data }) => {
  const { isOpen, openModal, closeModal } = useModal();
  const [deletionModal, setDeletionModal] = useState(false);
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const deleteSpecialty = async () => {
    try {
      const res = await requestApi({
        url: '/api/practitioner/specialty/delete',
        params: { id: data?.id },
        navigate
      });

      const { code, redirect, error } = res;
      switch (code) {
        case -1:
          navigate(redirect);
          break;
        case 0:
          showAlert({
            title: `Deleted specialty ${data.id}`,
            color: 'success'
          });
          await queryClient.invalidateQueries(['specialty']);
          break;
        default:
          if (error) console.error(error);
          break;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const actionOptions = [
    {
      label: 'Edit',
      icon: 'new-edit',
      onClick: () => openModal()
    },
    {
      label: 'Delete',
      icon: 'trash-mono',
      onClick: () => setDeletionModal(true)
    }
  ];

  return (
    <>
      <Popover
        isFixed
        position="left"
        isBorder={false}
        options={actionOptions}
        className="flex h-full items-center"
      />
      <Confirm
        isOpen={deletionModal}
        title={`Delete Specialty ${data?.id}`}
        message="Are you sure you want to delete this specialty?"
        variant="danger"
        icon="trash-mono"
        handleClose={() => setDeletionModal(false)}
        handleContinue={() => {
          deleteSpecialty();
          setDeletionModal(false);
        }}
      />
      <SpecialtyModal
        specialtyData={data}
        isOpen={isOpen}
        modalType="edit"
        handleClose={closeModal}
      />
    </>
  );
};

export default Actions;
